export const governmentResume = {
  id: 'government-resume',
  version: 2,
  renderer: 'enterprise',
  name: 'Federal & Government Resume',
  layout: 'single-column',
  theme: 'slate-executive',
  density: 'dense',
  persona: ['government'],
  atsLevel: 'A+',
  scoreWeights: {
    ats: 50,
    visual: 10,
    executive: 30,
    student: 10
  },
  metadata: {
    industry: ['Civil Service', 'Federal Government', 'Defense Sector'],
    companies: ['NASA', 'Department of Defense', 'IRS', 'FBI', 'Federal Aviation Administration', 'State Department'],
    ats: ['USAJOBS', 'Monster Government Solutions', 'Taleo'],
    pages: { min: 2, max: 10, preferred: 4 },
    photo: false,
    icons: false,
    columns: 1,
    centeredHeader: true,
    experienceLevel: ['GS-7', 'GS-9', 'GS-11', 'GS-13', 'GS-15', 'SES'],
    careerStage: 'Professional',
    recommendedFor: ['Federal Applicants', 'Civil Servants', 'Military Veterans', 'Government Contractors'],
    avoidFor: ['Creative Directors', 'Software Engineers applying to startups', 'Art Directors'],
    dna: ['Federal-Dense', 'Compliance-Maximal', 'Georgia-Serif', 'Centered-Header', 'USAJOBS-Native'],
    metrics: {
      readingDifficulty: 99,
      scanningSpeed: 89,
      visualAppeal: 75
    },
    hiringManager: {
      firstImpression: "Extremely thorough, compliant, process-oriented public service professional",
      scanningStyle: "Detailed reading focusing on grade levels (GS), citizenship, clearance status, and compliance match",
      preferredStructure: "Experience (highly detailed), education, certifications, skills",
      dislikes: ["Brief summaries", "Creative layouts", "Icons or visual ratings", "Lack of exact dates or hours worked"]
    },
    strategy: {
      goal: "Pass strict federal USAJOBS compliance check systems and showcase complete job history",
      focus: "Detailed scope of responsibilities, hours worked per week, GS series salary equivalence, security clearance details",
      avoid: ["Gimmicky design elements", "Sidebar structures"]
    },
    psychology: {
      coreTraits: ["Compliance", "Trustworthiness", "Public-service alignment", "Methodical discipline"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: false,
      linear: true,
      sidebar: false
    },
    aiPrompt: {
      writingStyle: "Use comprehensive, highly detailed descriptions of responsibilities, processes, and compliance achievements. Include GS levels, citizenship details, security clearance level, and exact hours worked per week.",
      rewriteStyle: "Formal, detailed, compliance-focused"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9.5pt",
      lineHeight: 1.4,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: true,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: false,
      html: true
    }
  },
  layouts: {
    'single-column': {
      component: 'single-column',
      slots: {
        header: ['personal-info'],
        main: ['experience', 'education', 'certifications', 'skills']
      },
      overrides: {
        '--font-family-primary': 'Georgia, serif',
        '--spacing-margin': '24px'
      }
    }
  },
  sectionOrder: ['personal-info', 'experience', 'education', 'certifications', 'skills'],
  components: {
    header: 'personal-info',
    main: ['experience', 'education', 'certifications', 'skills'],
  },
  capabilities: {
    photo: false,
    icons: false,
    multiColumn: false,
    colorAccent: false,
    atsOptimized: true,
  },
  styleOverrides: {
    '--font-size-display': '26pt',
    '--weight-display': '800',
    '--heading-text-transform': 'uppercase',
    '--heading-letter-spacing': '0.08em',
    '--heading-weight': '800',
    '--border-thickness-heading': '2.5px',
    '--bullet-style': 'disc',
    '--spacing-section-mb': '24px',
    '--spacing-item-mb': '14px',
    '--spacing-bullet-gap': '6px'
  }
};
export default governmentResume;
